import Axios from 'axios'

const axios = Axios.create({
  baseURL: 'https://api.mi-sos.org/sos/',
  //baseURL: 'https://api.merls.org/sos/',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    //'Content-Type': 'text/html',
    'Accept': 'application/json',
    //'X-CSRF-TOKEN': window.csrfToken, 
    //'X-Requested-With': 'XMLHttpRequest',
  }
})
//axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.withCredentials = true;
export default axios;
